<template>
    <v-flex xs12>
        <v-expansion-panel v-for="level in levels" :key="level.id"
                           v-model="value.panelShow[level.id]"
                           style="background:transparent"
                           expand
                           class="catalog-item-menu-level-panel"
        >
            <v-expansion-panel-content v-if="level.items.length > 0"
                                       style="background:transparent">
                <template v-slot:header>
                    <h3 class="primary--text">{{level.description}}
                      <span class="secondary--text bold" v-if="level.mandatory === 1">&nbsp;*</span>
                    </h3>
                    <!-- TODO Ivo: display the maximum number of items that can be selected
                    Hints:
                        v-if="level.maximum_items > 0"
                        {{level.maximum_items}}
                        -->
                </template>

                <v-flex x12 v-if="level.multiple === 0">
                    <v-radio-group
                            class="shop-delivery-choices"
                            :mandatory="level.mandatory === 1"
                            v-model="value.selectedLevelsIds[level.id]">

                        <v-list one-line>
                            <v-list-tile v-for="item in level.items"
                                         :key="item.item_id"
                                         class="v-list__tile--link">

                                <v-list-tile-avatar>
                                    <v-radio
                                            :key="item.item_id"
                                            :value="item.item_id"
                                    ></v-radio>
                                </v-list-tile-avatar>
                                <v-list-tile-avatar v-if="item.item_image && baseUrl">
                                  <v-img v-bind:src="baseUrl + item.item_image"
                                         aspect-ratio="1.48"
                                         style="border-radius: 0">
                                  </v-img>
                                </v-list-tile-avatar>
                                <!-- TODO: para colocar a funcionar o click na linha toda; adicionar ao v-list-tile-content @click="addSelectedItem('radio',levelId,item)"-->
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{item.item_name}}
                                    </v-list-tile-title>

                                    <v-list-tile-sub-title>
                                        <span v-for="(choice, index) in subLevelsChoices[item.item_id]" :key="index">
                                        <!-- {{choice.level}}: -->
                                          {{choice.items}} |
                                        </span>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action v-if="item.levels && item.levels.length > 0 && value.selectedLevelsIds[level.id] && value.selectedLevelsIds[level.id] == item.item_id">
                                        <v-btn medium
                                                color="secondary"
                                                @click="displayDialog(level.id)"
                                        >
                                            {{$vuetify.t('$vuetify.shop.item_define_menu_extra')}}
                                        </v-btn>
                                  <DialogListMenuLevels
                                            :levels="item.levels"
                                            v-model="value"
                                            :show="value.showDialog[level.id]"
                                            @close="handleDialogClose(level.id)"
                                    ></DialogListMenuLevels>
                                </v-list-tile-action>

                                <v-list-tile-action class="secondary--text nowrap" style="margin-left: 5px" v-if="item.item_unit_price > 0">
                                    + {{item.item_unit_price}} {{currencySymbol}}
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-radio-group>
                </v-flex>

                <v-flex x12 v-if="level.multiple === 1">
                    <v-list one-line>
                        <v-list-tile v-for="item in level.items"
                                     :key="item.item_id"
                                     class="v-list__tile--link">

                            <v-list-tile-avatar>
                                <v-checkbox
                                        :key="item.item_id"
                                        v-model="value.selectedLevelsIds[level.id+'_'+item.item_id]"
                                        :value="item.item_id"
                                        @change="verifyLimitReached($event, level.id)"
                                        :disabled="value.disableLevel[level.id] === 1 && !value.selectedLevelsIds[level.id+'_'+item.item_id]"></v-checkbox>
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-if="item.item_image && baseUrl">
                              <v-img v-bind:src="baseUrl + item.item_image"
                                     aspect-ratio="1.48"
                                     style="border-radius: 0">
                              </v-img>
                            </v-list-tile-avatar>
                            <!--TODO: para colocar a funcionar o click na linha toda; adicionar ao v-list-tile-content @click="addSelectedItem('check', levelId+'_'+item.item_id, item)"-->
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{item.item_name}}
                                </v-list-tile-title>

                            </v-list-tile-content>

                            <v-list-tile-action class="secondary--text nowrap" v-if="item.item_unit_price > 0">
                                + {{item.item_unit_price}}&nbsp;{{currencySymbol}}
                            </v-list-tile-action>

                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-flex>
</template>

<script>
    import {mapGetters} from "vuex";
    import DialogListMenuLevels from '@/components/DialogListMenuLevels.vue';

    export default {
        name: "ItemsListMenuLevels",
        components: {DialogListMenuLevels},
        props: {
            levels: Array,
            value: Object,
        },
        data() {
            return {}
        },
        methods: {
            //TODO: para colocar a funcionar o click na linha toda; usar this.$forceUpdate(); que é o que faz isto funcionar
            // /**
            //  *
            //  * @param selectType
            //  * @param levelId
            //  * @param item
            //  */
            // addSelectedItem(selectType, levelId, item) {
            //     // this.value.selectedItem[levelId] = item
            //     //se for uma checkbox tenho de tirar? nao ha forma melhorpara fazer isto?
            //     console.log(selectType, levelId, item)
            //
            //     this.value.selectedLevels[levelId] = item;
            //
            //     console.log('selectedLevels', this.value.selectedLevels)
            //
            // },
            verifyLimitReached(val, levelId) {
                this.$log.debug("Detail Menu | Evaluate Limit Reached for level " + levelId);

                let selectedOptions = [];
                let levelToVerify = this.levels.find(level => level.id == levelId);

                this.$log.debug("Menu Levels List Item | Evaluate Limit Reached for Level " + levelId + " which accepts " + levelToVerify.maximum_items + " options");

                if (levelToVerify.maximum_items > 0) {
                    for (let levelId in this.value.selectedLevelsIds) {
                        this.$log.debug("Detail Menu | Iterating on Level " + levelId);
                        if (this.value.selectedLevelsIds[levelId] !== null) {
                            if (levelId.includes("_")) {
                                if (levelId.split("_")[0] == levelToVerify.id) {
                                    this.$log.debug("Detail Menu | Iterated Level " + levelId.split("_")[0] + " matches with level " + levelId);
                                    if (!selectedOptions.includes(levelId.split("_")[1])) {
                                        this.$log.debug("Detail Menu | Iterated Level " + levelId.split("_")[0] + " added new choice " + levelId.split("_")[1]);
                                        selectedOptions.push(levelId.split("_")[1]);
                                    }
                                }
                            }
                        }

                    }
                    this.$log.debug("Detail Menu | The selected options: " + selectedOptions + " ; count: " + selectedOptions.length);
                    if (selectedOptions.length >= levelToVerify.maximum_items) {
                        this.$log.debug("Detail Menu | Maximum Number of choices reached");
                        //@deprecated
                        // this.value.panelShow[levelId] = 1;
                        this.value.disableLevel[levelId] = 1;
                    } else {
                        this.$log.debug("Detail Menu | The user can select more Items");
                        //@deprecated
                        // this.value.panelShow[levelId] = 0;
                        this.value.disableLevel[levelId] = 0;
                    }
                } else {
                    this.$log.debug("Detail Menu | No restrictions to apply");
                    //@deprecated
                    // this.value.panelShow[levelId] = 0;
                    this.value.disableLevel[levelId] = 0;
                }
            },
            displayDialog(levelId) {
                this.value.showDialog[levelId] = true;
                this.$forceUpdate();
            },
            handleDialogClose(levelId) {
                this.value.showDialog[levelId] = false;
                this.$forceUpdate();
            }
        },
        computed: {
            ...mapGetters({
                currencySymbol: 'configs/currencySymbol',
                baseUrl: 'configs/apiImgBaseUrl',
            }),
            /**
             *
             */
            subLevelsChoices() {

                this.$log.debug("Detail Menu | Organize Sub Levels Choices");
                let subLevelsChoices = {};

                let localLevelsItemsFlat = this.value.levelsItemsFlat;

                //Iterating over the selected options
                for (let levelId in this.value.selectedLevelsIds) {
                    if (localLevelsItemsFlat[levelId]) {
                        this.$log.debug("Detail Menu | Organize Sub Levels Choices | Level '" + localLevelsItemsFlat[levelId].description + "' (" + levelId + ")");
                    }
                    //Verifying if the selected option has a value. The checkboxes once "unselected" are included on the selectedLevelsIds but with the selected value = null.
                    // Example: 907_3601: null
                    if (this.value.selectedLevelsIds[levelId] !== null) {
                        //The selected Item
                        let selectedLevelOptionId = this.value.selectedLevelsIds[levelId];
                        //The definition of the selected Item: name, price, parent level (if exists)
                        let menuItem = localLevelsItemsFlat[selectedLevelOptionId];
                        //The Items of sub levels, should only be taken into account if the main level is selected
                        if (menuItem.parent_item && menuItem.parent_item_level) {
                            this.$log.debug("Detail Menu |  Organize Sub Levels Choices | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which belongs to level " + menuItem.parent_item_level);
                            if (!this.value.selectedLevelsIds[menuItem.parent_item_level] || this.value.selectedLevelsIds[menuItem.parent_item_level] !== menuItem.parent_item) {
                                this.$log.debug("Detail Menu |  Organize Sub Levels Choices | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS NOT selected");
                                continue;
                            }
                            this.$log.debug("Detail Menu |  Organize Sub Levels Choices | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS selected");
                            if (!subLevelsChoices[menuItem.parent_item]) {
                                subLevelsChoices[menuItem.parent_item] = [];
                            }
                            subLevelsChoices[menuItem.parent_item].push({
                                'level': localLevelsItemsFlat[levelId].description,
                                'items': menuItem.item_name
                            });
                        }

                    }
                }
                return subLevelsChoices;
            }
        }
    }
</script>

<style scoped>

</style>